import {
  HHBox,
  HHDateRangePicker,
  HHStack,
  HHTextField,
  HHTypography,
} from '@hinge-health/react-component-library';
import { datePicker } from '../constants/hinge-connect-constants.constant';

export type DateRangePickerValue = Date | null;

interface DateRangePickerProps {
  label?: string;
  helperText?: string;
  dateRange: [DateRangePickerValue, DateRangePickerValue];
  setDateRange: React.Dispatch<
    React.SetStateAction<[DateRangePickerValue, DateRangePickerValue]>
  >;
  startDateTestId?: string;
  endDateTestId?: string;
}

export const DateRangePicker = ({
  label,
  helperText,
  dateRange,
  setDateRange,
  startDateTestId,
  endDateTestId,
}: DateRangePickerProps): JSX.Element => (
  <HHBox marginY="1rem">
    {label && <HHTypography hhVariant="input-label">{label}</HHTypography>}
    <HHDateRangePicker
      localeText={{
        start: datePicker.startDate,
        end: datePicker.endDate,
      }}
      onChange={(data): void => {
        setDateRange(data);
      }}
      value={dateRange}
      renderInput={(startProps, endProps): JSX.Element => (
        <HHStack direction="row" spacing={6} alignItems="center">
          <HHTextField
            hhVariant="variant-bypass"
            {...startProps}
            inputProps={{
              ...startProps.inputProps,
              'data-testid': startDateTestId,
            }}
          />
          <HHTypography hhVariant="body">{datePicker.to}</HHTypography>
          <HHTextField
            hhVariant="variant-bypass"
            {...endProps}
            inputProps={{
              ...endProps.inputProps,
              'data-testid': endDateTestId,
            }}
          />
        </HHStack>
      )}
    />
    {helperText && (
      <HHTypography hhVariant="input-label">{helperText}</HHTypography>
    )}
  </HHBox>
);
